import React from 'react';
import { connect } from 'react-redux';
import { setActiveBlock, setHologramPosition, addToSwap } from 'components/collage/CollageSlice.js';

// JS libs
// import '@deckdeckgo/drag-resize-rotate';
import '@deckdeckgo/drag-resize-rotate';

// CSS
import './FreeMove.css';

class FreeMove extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  render() {
    return (
      <deckgo-drr 
        text={true} 
        class={'FreeMove'}
        data-index={this.props.index}
        style={{
          // 'top': '22px',
          '--left': '20%',
          '--top': '20%,',
          '--width': 'auto', 
          '--height': 'auto', 
          '--deckgo-drr-border': 'dotted 5px #FFFFFF', 
          '--deckgo-drr-rotate-anchor-action-border': 'solid 2px #FFFFFF',
          '--deckgo-drr-rotate-anchor-presentation-border-right': 'solid 2px #FFFFFF',
          '--deckgo-drr-rotate-anchor-width': '42px',
          '--deckgo-drr-rotate-anchor-height': '42px',
          '--deckgo-drr-rotate-anchor-action-width': '20px',
          '--deckgo-drr-rotate-anchor-action-height': '20px',
          '--deckgo-drr-rotate-anchor-presentation-width': '20px',
          '--deckgo-drr-rotate-anchor-presentation-height': '20px',
        }}>
        {this.props.children}
      </deckgo-drr>
    );
  }
}

const mapStateToProps = state => ({
  collage: state.collage
});

export default connect(
  mapStateToProps,
  {setActiveBlock, setHologramPosition, addToSwap}
)(FreeMove)
